{
	"titleFirstPart": "Bine ai venit la",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Total carbon stocat"
}
